<script>
import {mapGetters} from 'vuex';

import {UI_MAP_READY} from "@/shared/components/map-viewer/constants/map-events";
import {LOADING_PROGRESS, OBJECT_INFO_CLOSE_CLICK} from "@/utils/constants/bus-events-constants";

export default {
    name: "OIntegrationEventsController",

    data() {
        return {
            mapStartLoadingTime: 0,
            localHeartbeatIntervalPointer: null,
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp',
        ]),

    },
    methods: {
        sendPostMessage(event){
            window.parent && window.parent.postMessage(event, '*');
        },
        sendPostMessageToTop(event){
            window.top && window.top.postMessage(event, '*');
        },

        postToParent(event, data){
            const namespace = 'mvg_map';
            const name = event;
            this.sendPostMessage({
                namespace, event, name, data
            });
        },
        postToTop(event, data = null){
            const namespace = 'mvg_map';
            const name = event;
            this.sendPostMessageToTop({
                namespace, name, event, data
            });
        },

        onMapReady(){
            this.postToParent("mvg_map_loading_progress", 100);
            this.postToParent("mvg_map_ready");

            this.postToTop("mvg_map_loading_progress", 100);
            this.postToTop("mvg_map_ready");
        },
        onCloseClick(){
            this.postToTop("mvg_map_close_emitted");
        },
        onObjectSelect(objectId){
            this.postToTop("mvg_map_object_selected", objectId);
        },
        onGuideRequest(objectId){
            this.postToTop("mvg_map_guide_requested", objectId);
        },
        onLoadingProgress(progress){
            this.postToParent("mvg_map_loading_progress", progress);
            this.postToTop("mvg_map_loading_progress", progress);
        },
    },
    mounted() {
        this.$bus.$on(UI_MAP_READY, this.onMapReady);
        this.$bus.$on(LOADING_PROGRESS, this.onLoadingProgress);
        this.$bus.$on(OBJECT_INFO_CLOSE_CLICK, this.onCloseClick);
    },
    beforeDestroy() {
        this.$bus.$off(UI_MAP_READY, this.onMapReady);
        this.$bus.$off(LOADING_PROGRESS, this.onLoadingProgress);
        this.$bus.$off(OBJECT_INFO_CLOSE_CLICK, this.onCloseClick);
    },
    render(){ return null }
}
</script>
